export const wordPackState =  {
    state:() => ({
      packs: new Map(),
      selectedPacks: []
    }),
    getters: {
      packs: state => {
        return state.packs;
      },
      selected: state => {
        return state.selectedPacks;
      }
    },
    mutations: {
    },
    actions: {
  
    }
};
